import Button from './TouchableOpacity';

export default Button;
